/**
 * Update date: 31-05-2023
 * Screen 2047.2
 */
import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import React, { createContext, useContext, useState } from 'react';

const List = React.lazy(() => import('./List'));
const ViewEdit = React.lazy(() => import('./ViewEdit'));
/**
 * create context
 */
const RegistrationForRegularDeliveryScheduleContext = createContext({});

RegistrationForRegularDeliveryScheduleContext.displayName =
  'RegistrationForRegularDeliveryScheduleContext';

export const useRegistrationForRegularDeliverySchedule = () => {
  return useContext(RegistrationForRegularDeliveryScheduleContext);
};

const RegistrationForRegularDeliverySchedule = () => {
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    store: null,
  });
  const [formSearchData, setFormSearchData] = useState<any>({
    dataList: {
      storeGroup: [],
      store: [],
    },
    storeGroup: '',
    store: '',
  });

  const [{ loading: loadingfetchData }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  const value: any = {
    data,
    setData,
    modeView,
    setModeView,
    refetchData,
    formSearchData,
    setFormSearchData,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'edit':
      case 'view':
        return <ViewEdit />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <RegistrationForRegularDeliveryScheduleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingfetchData} />
        {renderContent()}
      </React.Suspense>
    </RegistrationForRegularDeliveryScheduleContext.Provider>
  );
};

export default RegistrationForRegularDeliverySchedule;
